/**
 * created by zhouzt on 2020-05-08
 *
 * description: 弹窗列表接口
 *
 */

const config = require('libs/config.js')

const dialog = {
	// 供应商采购方接口
	getMemberByJsxz: config.MS_XY_PATH + '/outline/web2/basic/queryMemberByJsxz',
	// 查询招投标单号
	getBuyBiddingList: config.MS_XY_PATH + '/outline/bidding/queryContract',
	// 查询买方招投标单号
	getSellBiddingList: config.MS_XY_PATH + '/outline/bidding/querySellContract',
	// 查询买方竞谈单号
	getCompetitiveList: config.MS_XY_PATH + '/outline/nego/queryContract',
	// 查询卖方竞谈单号
	getSellCompetitiveList: config.MS_XY_PATH + '/outline/nego/querySellContract',
	// 制造商接口
	getMakerList: config.MS_XY_PATH + '/outline/inquiry/getManufacturer',
	// 获取采购方会员类型
	getBuyType: config.MS_XY_PATH + '/outline/web2/basic/getGroupFlagList',

	// 查询买方询价单号
	getBuyInquiryList: config.MS_XY_PATH + '/outline/inquiry/findBuyContractByPage',
	// 查询买方询价单号
	getBuyInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/getBuyHangQueryInfo',

	// 查询卖方询价单号
	getSellInquiryList: config.MS_XY_PATH + '/outline/inquiry/findSellContractByPage',
	// 查询卖方询价单号
	getSellInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/getSellHangQueryInfo',

	// 查询买方询价单号（新）
	getNewBuyInquiryList: config.MS_XY_PATH + '/outline/inquiry/queryBuyContractByPage',
	// 查询卖方询价单号（新）
	getNewSellInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/querySellContractByPage',
	// 查询买方询价单号（新）
	getNewInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/getInquiryInfo',
	// 查询买方询价单号（新）
	getMergeBuyInquiryList: config.MS_XY_PATH + '/outline/inquiry/merge/queryBuyContractByPage',
	// 查询卖方询价单号（新）
	getMergeSellInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/merge/querySellContractByPage',
	// 查询买方询价单号（新）
	getMergeInquiryInfo: config.MS_XY_PATH + '/outline/inquiry/merge/getInquiryInfo',

	
}

export default dialog



// WEBPACK FOOTER //
// ./src/api/dialog/index.js